/**
 * FJ Quick View System
 * Opens product details in a modal popup
 */
(function () {
  const modal = document.getElementById('fjQuickView');
  const template = document.getElementById('fjQvTemplate');
  const content = document.getElementById('fjQvContent');
  const closeBtn = modal?.querySelector('.fj-qv-close');

  if (!modal || !template || !content) return;

  let currentProduct = null;
  let currentVariant = null;

  // Open modal
  function openModal() {
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // Close modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      content.innerHTML = '<div class="fj-qv-loading"><div class="fj-qv-spinner"></div><p>Laster produkt...</p></div>';
    }, 250);
  }

  // Fetch product data
  async function fetchProduct(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch product:', error);
      return null;
    }
  }

  // Badge helper
  function getBadges(product) {
    const badges = [];
    const tags = product.tags.map(t => t.toLowerCase());

    // Check for sale
    if (product.compare_at_price && product.price < product.compare_at_price) {
      badges.push({ text: 'Salg', class: 'fj-qv-badge--sale' });
    }

    // Check tags
    if (tags.some(t => t.includes('nyhet') || t.includes('new'))) {
      badges.push({ text: 'Nyhet', class: 'fj-qv-badge--new' });
    }
    if (tags.some(t => t.includes('anbefalt') || t.includes('recommended'))) {
      badges.push({ text: 'Anbefalt', class: 'fj-qv-badge--recommended' });
    }
    if (tags.some(t => t.includes('bestselger') || t.includes('bestseller'))) {
      badges.push({ text: 'Bestselger', class: 'fj-qv-badge--bestseller' });
    }

    return badges.slice(0, 2); // Max 2 badges
  }

  // Format price
  function formatPrice(cents) {
    const kr = (cents / 100).toFixed(2).replace('.', ',');
    return `${kr} kr`;
  }

  // Render product
  function renderProduct(product) {
    currentProduct = product;
    currentVariant = product.variants[0];

    const clone = template.content.cloneNode(true);

    // Vendor
    const vendor = clone.querySelector('.fj-qv-vendor');
    if (product.vendor) {
      vendor.textContent = product.vendor;
    } else {
      vendor.style.display = 'none';
    }

    // Title
    clone.querySelector('.fj-qv-title').textContent = product.title;

    // Badges
    const badgesContainer = clone.querySelector('.fj-qv-badges');
    const badges = getBadges(product);
    badges.forEach(badge => {
      const span = document.createElement('span');
      span.className = `fj-qv-badge ${badge.class}`;
      span.textContent = badge.text;
      badgesContainer.appendChild(span);
    });

    // Main image
    const img = clone.querySelector('.fj-qv-img');
    if (product.featured_image) {
      img.src = product.featured_image.replace(/\.(jpg|jpeg|png|webp)/i, '_600x600.$1');
      img.alt = product.title;
    }

    // Thumbnails
    const thumbsContainer = clone.querySelector('.fj-qv-thumbnails');
    if (product.images && product.images.length > 1) {
      product.images.slice(0, 6).forEach((imgUrl, idx) => {
        const thumb = document.createElement('div');
        thumb.className = `fj-qv-thumb ${idx === 0 ? 'is-active' : ''}`;
        thumb.innerHTML = `<img src="${imgUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_100x100.$1')}" alt="">`;
        thumb.addEventListener('click', () => {
          img.src = imgUrl.replace(/\.(jpg|jpeg|png|webp)/i, '_600x600.$1');
          thumbsContainer.querySelectorAll('.fj-qv-thumb').forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
        thumbsContainer.appendChild(thumb);
      });
    }

    // Price
    const priceContainer = clone.querySelector('.fj-qv-price');
    priceContainer.innerHTML = `<span class="fj-qv-price--current">${formatPrice(product.price)}</span>`;

    if (product.compare_at_price && product.compare_at_price > product.price) {
      const savings = product.compare_at_price - product.price;
      const savingsPercent = Math.round((savings / product.compare_at_price) * 100);
      priceContainer.innerHTML += `<span class="fj-qv-price--compare">${formatPrice(product.compare_at_price)}</span>`;
      priceContainer.innerHTML += `<span class="fj-qv-price--save">Spar ${savingsPercent}%</span>`;
    }

    // Rating (if available from metafields)
    const ratingContainer = clone.querySelector('.fj-qv-rating');
    const ratingValue = product.metafields?.reviews?.rating?.value || 0;
    const ratingCount = product.metafields?.reviews?.rating_count || 0;

    if (ratingValue > 0) {
      const fullStars = Math.floor(ratingValue);
      const decimal = ratingValue % 1;
      const hasHalf = decimal >= 0.25 && decimal < 0.75;
      let emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
      if (decimal >= 0.75) emptyStars--;

      let starsHTML = '';

      // Full stars
      for (let i = 0; i < fullStars; i++) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--full" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      // Half star
      if (hasHalf) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--half" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="half-qv">
              <stop offset="50%" stop-color="#fbbf24"/>
              <stop offset="50%" stop-color="rgba(0,0,0,0.15)"/>
            </linearGradient>
          </defs>
          <path fill="url(#half-qv)" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      // Empty stars
      for (let i = 0; i < emptyStars; i++) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      ratingContainer.innerHTML = `
        <div class="fj-qv-stars">${starsHTML}</div>
        ${ratingCount > 0 ? `<span class="fj-qv-rating-count">(${ratingCount})</span>` : ''}
      `;
    } else {
      ratingContainer.style.display = 'none';
    }

    // Hide short description - we only use accordion now
    const desc = clone.querySelector('.fj-qv-description');
    if (desc) {
      desc.style.display = 'none';
    }

    // Accordion: Full Description - open by default if description exists
    const fullDescEl = clone.querySelector('.fj-qv-full-description');
    const fullDescItem = fullDescEl?.closest('.fj-qv-accordion-item');
    if (product.description && fullDescEl) {
      fullDescEl.innerHTML = product.description;
      // Auto-open the full description accordion
      if (fullDescItem) {
        fullDescItem.classList.add('is-open');
        const fullDescContent = fullDescItem.querySelector('.fj-qv-accordion-content');
        if (fullDescContent) {
          fullDescContent.style.maxHeight = '500px';
        }
      }
    } else if (fullDescItem) {
      fullDescItem.style.display = 'none';
    }

    // Accordion: Technical Specs
    const techSpecsEl = clone.querySelector('.fj-qv-tech-specs');
    const techSpecsItem = techSpecsEl?.closest('.fj-qv-accordion-item');
    const techSpecs = product.metafields?.custom?.technical_specs;
    if (techSpecs && techSpecsEl) {
      techSpecsEl.textContent = techSpecs;
    } else if (techSpecsItem) {
      techSpecsItem.style.display = 'none';
    }

    // Accordion: Delivery Info
    const deliveryInfoEl = clone.querySelector('.fj-qv-delivery-info');
    const deliveryInfoItem = deliveryInfoEl?.closest('.fj-qv-accordion-item');
    const deliveryInfo = product.metafields?.custom?.delivery_info;
    if (deliveryInfo && deliveryInfoEl) {
      deliveryInfoEl.textContent = deliveryInfo;
    } else if (deliveryInfoItem) {
      deliveryInfoItem.style.display = 'none';
    }

    // Availability
    const availabilityContainer = clone.querySelector('.fj-qv-availability');
    availabilityContainer.innerHTML = ''; // Clear existing content

    // Check for metafields
    const clickCollect = product.metafields?.custom?.click_collect !== false;
    const storeLocations = product.metafields?.custom?.store_locations || 'Tau';
    const supplierWarehouse = product.metafields?.custom?.supplier_warehouse !== false;
    const supplierDays = product.metafields?.custom?.supplier_days || '2-4';

    // Butikklager / Click & Collect
    if (clickCollect) {
      const storeEl = document.createElement('div');
      storeEl.className = product.available ? 'fj-qv-stock' : 'fj-qv-stock fj-qv-stock--out';
      storeEl.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <div>
          <strong>Click & Collect / Butikklager</strong><br>
          <span class="fj-qv-stock-status">${product.available ? 'På lager i butikk (' + storeLocations + ')' : 'Ikke på lager i butikk'}</span>
        </div>
      `;
      availabilityContainer.appendChild(storeEl);
    }

    // Fjernlager (vises alltid)
    if (supplierWarehouse) {
      const supplierEl = document.createElement('div');
      supplierEl.className = 'fj-qv-supplier';
      supplierEl.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="1" y="3" width="15" height="13"/>
          <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        <div>
          <strong>Fjernlager</strong><br>
          <span>Sendes normalt innen ${supplierDays} virkedager</span>
        </div>
      `;
      availabilityContainer.appendChild(supplierEl);
    }

    // Variants - Dropdown style
    const variantsContainer = clone.querySelector('.fj-qv-variants');
    if (product.options && product.options.length > 0 && product.variants.length > 1) {
      product.options.forEach((option, optionIndex) => {
        const group = document.createElement('div');
        group.className = 'fj-qv-variant-group';

        const label = document.createElement('label');
        label.className = 'fj-qv-variant-label';
        label.htmlFor = `fj-qv-select-${optionIndex}`;
        label.textContent = option.name;
        group.appendChild(label);

        // Create dropdown select
        const select = document.createElement('select');
        select.className = 'fj-qv-variant-select';
        select.id = `fj-qv-select-${optionIndex}`;
        select.name = `fj-qv-option-${optionIndex}`;

        // Get unique values for this option
        const values = [...new Set(option.values)];

        values.forEach((value) => {
          const optionEl = document.createElement('option');
          optionEl.value = value;
          optionEl.textContent = value;

          // Check if this is the selected variant's value
          if (currentVariant[`option${optionIndex + 1}`] === value) {
            optionEl.selected = true;
          }

          select.appendChild(optionEl);
        });

        select.addEventListener('change', () => handleVariantChange());

        group.appendChild(select);
        variantsContainer.appendChild(group);
      });
    } else {
      variantsContainer.style.display = 'none';
    }

    // Form
    const form = clone.querySelector('.fj-qv-form');
    const variantInput = form.querySelector('.fj-qv-variant-id');
    variantInput.value = currentVariant.id;

    form.addEventListener('submit', handleAddToCart);

    // Full product link
    const fullLink = clone.querySelector('.fj-qv-full-link');
    fullLink.href = `/products/${product.handle}`;

    // Replace content
    content.innerHTML = '';
    content.appendChild(clone);

    // Load related products
    loadRelatedProducts(product);
  }

  // Fetch related products from same collection or by tags
  async function loadRelatedProducts(product) {
    const relatedGrid = content.querySelector('.fj-qv-related-grid');
    if (!relatedGrid) return;

    try {
      // Get products from same collection (via Shopify's product recommendations API)
      const response = await fetch(`/recommendations/products.json?product_id=${product.id}&limit=4`);

      if (!response.ok) {
        relatedGrid.parentElement.style.display = 'none';
        return;
      }

      const data = await response.json();
      const relatedProducts = data.products || [];

      if (relatedProducts.length === 0) {
        relatedGrid.parentElement.style.display = 'none';
        return;
      }

      // Render related products
      relatedProducts.forEach(relatedProduct => {
        const card = document.createElement('div');
        card.className = 'fj-qv-related-card';
        const firstVariantId = relatedProduct.variants?.[0]?.id || '';
        card.innerHTML = `
          <button type="button" class="fj-qv-related-img" data-quick-view="${relatedProduct.handle}">
            <img src="${relatedProduct.featured_image?.replace(/\.(jpg|jpeg|png|webp)/i, '_200x200.$1') || ''}"
                 alt="${relatedProduct.title}"
                 loading="lazy">
          </button>
          <div class="fj-qv-related-info">
            <button type="button" class="fj-qv-related-name" data-quick-view="${relatedProduct.handle}">${relatedProduct.title}</button>
            <div class="fj-qv-related-price">${formatPrice(relatedProduct.price)}</div>
            <button type="button" class="fj-qv-related-add" data-variant-id="${firstVariantId}">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Legg i kurv
            </button>
          </div>
        `;
        relatedGrid.appendChild(card);
      });

      // Add event listener for related product clicks
      relatedGrid.addEventListener('click', async (e) => {
        const quickViewBtn = e.target.closest('[data-quick-view]');
        const addToCartBtn = e.target.closest('.fj-qv-related-add');

        if (quickViewBtn) {
          e.preventDefault();
          e.stopPropagation();
          const handle = quickViewBtn.dataset.quickView;
          // Show loading state
          content.innerHTML = '<div class="fj-qv-loading"><div class="fj-qv-spinner"></div><p>Laster produkt...</p></div>';
          // Load new product into same popup
          const newProduct = await fetchProduct(handle);
          if (newProduct) {
            renderProduct(newProduct);
          } else {
            content.innerHTML = '<div class="fj-qv-loading"><p>Kunne ikke laste produktet. Prøv igjen.</p></div>';
          }
        }

        if (addToCartBtn && !addToCartBtn.classList.contains('is-loading')) {
          e.preventDefault();
          e.stopPropagation();
          const variantId = addToCartBtn.dataset.variantId;
          if (variantId) {
            addToCartBtn.classList.add('is-loading');
            const originalHTML = addToCartBtn.innerHTML;
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
              });
              if (response.ok) {
                addToCartBtn.innerHTML = `
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  Lagt til!
                `;
                // Update cart count
                const cartCount = document.querySelector('.cart-count-bubble span, .fj-cart-badge');
                if (cartCount) {
                  const currentCount = parseInt(cartCount.textContent || '0');
                  cartCount.textContent = currentCount + 1;
                }
                setTimeout(() => {
                  addToCartBtn.innerHTML = originalHTML;
                  addToCartBtn.classList.remove('is-loading');
                }, 2000);
              } else {
                throw new Error('Failed to add');
              }
            } catch (err) {
              console.error('Add to cart failed:', err);
              addToCartBtn.classList.remove('is-loading');
            }
          }
        }
      });

    } catch (error) {
      console.error('Failed to load related products:', error);
      relatedGrid.parentElement.style.display = 'none';
    }
  }

  // Handle variant selection
  function handleVariantChange() {
    const form = content.querySelector('.fj-qv-form');
    const selectedOptions = {};

    currentProduct.options.forEach((option, idx) => {
      const select = content.querySelector(`select[name="fj-qv-option-${idx}"]`);
      if (select) {
        selectedOptions[`option${idx + 1}`] = select.value;
      }
    });

    // Find matching variant
    const variant = currentProduct.variants.find(v => {
      return Object.keys(selectedOptions).every(key => v[key] === selectedOptions[key]);
    });

    if (variant) {
      currentVariant = variant;
      form.querySelector('.fj-qv-variant-id').value = variant.id;

      // Update price
      const priceContainer = form.closest('.fj-qv-info').querySelector('.fj-qv-price');
      priceContainer.innerHTML = `<span class="fj-qv-price--current">${formatPrice(variant.price)}</span>`;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savings = variant.compare_at_price - variant.price;
        const savingsPercent = Math.round((savings / variant.compare_at_price) * 100);
        priceContainer.innerHTML += `<span class="fj-qv-price--compare">${formatPrice(variant.compare_at_price)}</span>`;
        priceContainer.innerHTML += `<span class="fj-qv-price--save">Spar ${savingsPercent}%</span>`;
      }

      // Update availability
      const stockEl = form.closest('.fj-qv-info').querySelector('.fj-qv-stock');
      const supplierEl = form.closest('.fj-qv-info').querySelector('.fj-qv-supplier');
      const supplierWarehouse = currentProduct.metafields?.custom?.supplier_warehouse !== false;

      if (variant.available) {
        // Variant er tilgjengelig lokalt
        if (stockEl) {
          stockEl.querySelector('.fj-qv-stock-status').textContent = 'På lager i butikk';
          stockEl.classList.remove('fj-qv-stock--out');
        }
      } else if (supplierWarehouse) {
        // Ikke lokalt lager, men tilgjengelig fra fjernlager
        if (stockEl) {
          stockEl.querySelector('.fj-qv-stock-status').textContent = 'Ikke på lager i butikk';
          stockEl.classList.add('fj-qv-stock--out');
        }
        // Fjernlager vises fortsatt - produktet er tilgjengelig
      } else {
        // Verken lokalt eller fjernlager - helt utsolgt
        if (stockEl) {
          stockEl.querySelector('.fj-qv-stock-status').textContent = 'Utsolgt';
          stockEl.classList.add('fj-qv-stock--out');
        }
      }
    }
  }

  // Handle add to cart
  async function handleAddToCart(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    form.classList.add('is-loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      // Show success message
      const successMsg = document.createElement('div');
      successMsg.className = 'fj-qv-success is-visible';
      successMsg.textContent = 'Produktet ble lagt til i handlekurven!';
      form.appendChild(successMsg);

      // Update cart count if exists
      const cartCount = document.querySelector('.cart-count-bubble span, .fj-cart-badge');
      if (cartCount) {
        const currentCount = parseInt(cartCount.textContent || '0');
        const quantity = parseInt(formData.get('quantity') || '1');
        cartCount.textContent = currentCount + quantity;
      }

      setTimeout(() => {
        successMsg.classList.remove('is-visible');
        setTimeout(() => successMsg.remove(), 300);
      }, 3000);

    } catch (error) {
      console.error('Add to cart failed:', error);
      alert('Kunne ikke legge til produktet. Prøv igjen.');
    } finally {
      form.classList.remove('is-loading');
    }
  }

  // Event listeners
  closeBtn?.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  // Accordion toggle in Quick View
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.fj-qv-accordion-header');
    if (!header) return;

    // Only handle clicks within Quick View modal
    if (!header.closest('.fj-qv-overlay')) return;

    e.preventDefault();
    e.stopPropagation();

    const item = header.closest('.fj-qv-accordion-item');
    if (!item) return;

    const content = item.querySelector('.fj-qv-accordion-content');
    if (!content) return;

    // Toggle accordion
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      content.style.maxHeight = '0';
    } else {
      // Close other accordions first
      const modalContainer = item.closest('.fj-qv-overlay');
      if (modalContainer) {
        modalContainer.querySelectorAll('.fj-qv-accordion-item.is-open').forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-open');
            const otherContent = otherItem.querySelector('.fj-qv-accordion-content');
            if (otherContent) otherContent.style.maxHeight = '0';
          }
        });
      }

      // Open this one
      item.classList.add('is-open');
      const inner = content.querySelector('.fj-qv-accordion-inner');
      if (inner) {
        content.style.maxHeight = inner.scrollHeight + 20 + 'px';
      }
    }
  });

  async function openQuickViewByHandle(productHandle, e) {
    if (!productHandle) return;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    openModal();

    const product = await fetchProduct(productHandle);
    if (product) {
      renderProduct(product);
    } else {
      content.innerHTML = '<div class="fj-qv-loading"><p>Kunne ikke laste produktet. Prøv igjen.</p></div>';
    }
  }

  // Trigger buttons
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.fj-quick-view-trigger');
    if (!trigger) return;
    await openQuickViewByHandle(trigger.dataset.productHandle, e);
  });

  // Product links inside guides/articles -> open quick view popup instead of leaving page
  document.addEventListener('click', async (e) => {
    const articleLink = e.target.closest('.article-template__content a[href*="/products/"]');
    if (!articleLink) return;

    const href = articleLink.getAttribute('href') || '';
    const match = href.match(/\/products\/([a-z0-9-]+)/i);
    if (!match) return;

    await openQuickViewByHandle(match[1], e);
  });

  // Handle Shopify section re-renders
  document.addEventListener('shopify:section:load', () => {
    // Quick View is already listening via delegation, no re-init needed
  });
})();
